








































































































































import { AggregationsAsFilters, FilterHelpers } from '@/components/filter/FilterHelpers';
import SelectableImage from '@/components/global/SelectableImage.vue';
import PreviewImgListItem from '@/components/preview-img/PreviewImgListItem.vue';
import * as ElasticSearch from '@/typings/interfaces/ElasticSearch';
import { ImageHelpers } from '@/utils/imageHelpers';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import Cookies from 'js-cookie';
import FilterDropdown from '@/components/filter/FilterDropdown.vue';
import SidePanelFinish from '@/components/side-panel/SidePanelFinish.vue';
import SidePanelCollection from '@/components/side-panel/SidePanelCollection.vue';
import SidePanelProductLines from '@/components/side-panel/SidePanelProductLines.vue';
import { FinishType } from '@/typings/enums/FinishType';
import { CollectionType } from '@/typings/enums/CollectionType';
import { Bucket } from '@/typings/interfaces/ElasticSearch';
import TrModal from '@/components/shared/TrModal.vue';
import SampleSelectorWizard from '@/components/global/SampleSelectorWizard.vue';
import IconSearch from '@/assets/svg/icons/icon-search.svg?inline';
import { ProductLineType } from "@/typings/enums/ProductLineType";
import {BreakPoint, mqMaxWidth} from "@/utils/mq";
import IconFilter from '@/assets/svg/icons/icon-filter.svg?inline';

@Component({
  name: 'FilterOptions',
  components: {
    SampleSelectorWizard,
    TrModal,
    SidePanelFinish,
    SidePanelCollection,
    SidePanelProductLines,
    FilterDropdown,
    SelectableImage,
    PreviewImgListItem,
    IconSearch,
    IconFilter
  },
})
export default class FilterOptions extends Mixins(ImageHelpers, FilterHelpers) {
  @Prop({ default: false }) private enableCollectionFilter!: boolean;
  private showSampleSelectorWizard: boolean = false;
  private searchValue: string = '';
  private showFilters: boolean = false;
  private isMobile: boolean = false;

  public onInputChange() {
    this.$store.dispatch('productSearch/setQuery', this.searchValue);
  }

  get isFiltersOpen(): boolean {
    return this.$store.getters['productSearch/filtersOpen'];
  }

  setShowSampleSelectorWizard(isShow: boolean) {
    this.showSampleSelectorWizard = isShow;
  }

  get currentMode(): string {
    return this.$store.getters['productSearch/sampleSearchMode'];
  }

  private getListOfFinishes(finishes: Bucket[]): FinishType[] {
    return finishes.map((finish) => finish.key) as FinishType[];
  }

  private getListOfCollections(collections: Bucket[]): CollectionType[] {
    return collections.map((collection) => collection.key) as CollectionType[];
  }

  private getListOfProductLines(productLines: Bucket[]): ProductLineType[] {
    const knownValues = Object.values(ProductLineType) as string[];
    return productLines
      .map((productLine) => productLine.key[0])
      .filter((key) => knownValues.includes(key)) as ProductLineType[];
  }

  // I haven't found a better way to make checkboxes interact with this better.
  get exteriorMode() {
    return this.currentMode == 'exterior';
  }

  set exteriorMode(val: boolean) {
    Cookies.set('sampleSearchMode', 'exterior');
    this.$store.dispatch('productSearch/setSampleSearchMode', 'exterior');
    this.$store.dispatch('productSearch/setActiveFilters', 'exterior');
  }

  get interiorMode() {
    return this.currentMode == 'interior';
  }

  set interiorMode(val: boolean) {
    Cookies.set('sampleSearchMode', 'interior');
    this.$store.dispatch('productSearch/setSampleSearchMode', 'interior');
    this.$store.dispatch('productSearch/setActiveFilters', 'interior');
  }

  get sidingsMode() {
    return this.currentMode == 'sidings';
  }

  set sidingsMode(val: boolean) {
    Cookies.set('sampleSearchMode', 'sidings');
    this.$store.dispatch('productSearch/setSampleSearchMode', 'sidings');
    this.$store.dispatch('productSearch/setActiveFilters', 'sidings');
  }

  get excludedProductLines(): Array<string> {
    let ret = this.$store.getters['productSearch/excludedProductLines'];
    return ret === undefined ? [] : ret;
  }

  public passedValue(name, key) {
    return this.isActiveFilter(name, key);
  }

  getNestedFilteredCount(aggregation: keyof AggregationsAsFilters, nested: string, key: string): number {
    const nestedAggregationResponse: ElasticSearch.NestedAggregation = this.results?.aggregations?.filtered[
      aggregation
    ] as ElasticSearch.NestedAggregation;
    const aggregationResponse: ElasticSearch.Aggregation = nestedAggregationResponse[
      `${aggregation}.${nested}`
    ] as ElasticSearch.Aggregation;
    return this.getDocCountForAggregationResponse(aggregationResponse, key);
  }

  getFilteredCount(aggregation: keyof AggregationsAsFilters, key: string): number {
    const aggregationResponse: ElasticSearch.Aggregation = this.results?.aggregations?.filtered[
      aggregation
    ] as ElasticSearch.Aggregation;
    return this.getDocCountForAggregationResponse(aggregationResponse, key);
  }

  updateFilters(event: Event, name: string, value: string) {
    const target: EventTarget = event.target as EventTarget;
    const checked = (target as HTMLInputElement).checked || false;
    if (checked) {
      this.$store.dispatch('productSearch/addFilter', { name, value });
    } else {
      this.$store.dispatch('productSearch/removeFilter', { name, value });
    }
  }

  public hasFilter(filterName: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.filters, filterName);
  }

  private getDocCountForAggregationResponse(aggregation: ElasticSearch.Aggregation, key: string): number {
    const find = aggregation.buckets.find((value: ElasticSearch.Bucket) => {
      const matchAgainst = (value as unknown as ElasticSearch.MultiTermBucket).key_as_string || value.key;
      return matchAgainst == key;
    });
    return (find && find.doc_count) || 0;
  }

  /** Dynamically show/hide filters */
  private toggleFilterVisibility() {
    this.showFilters = !this.showFilters;
  }


  beforeMount() {
      const mq = mqMaxWidth(BreakPoint.LG);
      this.isMobile = mq.matches;
      mq.addEventListener('change', (ev: MediaQueryListEvent) => {
        this.isMobile = ev.matches;
      });
  }
  mounted() {
    if (this.isMobile) {
      this.showFilters = false;
    } else {
      this.showFilters = true;
    }
  }
}
